import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import useWindowSize from "../../hooks/useWindowSize";
import { ClipLoader } from "react-spinners";

const PlaceHolderImage = ({ imageUrl, handleUnlock, isModalLoading }) => {
  const { width, height } = useWindowSize();
  return (
    <div className="relative h-[215px] w-full overflow-hidden rounded-[12px] md:h-[380px]">
      <div
        className="absolute top-0 left-0 flex h-full w-full flex-col items-center justify-center bg-black/50 leading-none backdrop-blur-md"
        onClick={handleUnlock}
      >
        <img
          src="https://img.learntube.ai/public-assets/personalise-app-lesson/Onboarding/Group%2023607.webp"
          width={width < 768 ? 102 : 182}
          height={height < 768 ? 70 : 125}
          alt="placeholder"
        />
        <div className=" mt-5 text-[24px] font-bold text-white md:text-[32px]">
          This Lesson Is Locked!
        </div>
        {isModalLoading ? (
          <ClipLoader size={20} color="#fff" className="mt-3" />
        ) : (
          <span className="mt-3 text-[12px] text-white/70 md:text-[20px] ">
            Unlock the course now to continue watching{" "}
            <FontAwesomeIcon icon={faArrowRight} />
          </span>
        )}
      </div>
      <img
        src={imageUrl}
        alt="placeholder"
        className="h-full w-full object-cover"
      />
    </div>
  );
};

export default PlaceHolderImage;
